import React, { useEffect } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { EditRounded } from "@mui/icons-material";
import { Typography } from "@mui/material";
import "./styles.scss";
import { useState } from "react";
import { Partner } from "../../../types/genericType";
import { generateClientName } from "../../../utils/utils";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Stack,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";

type PartnersTablePropType = {
  partnersData: Partner[];
  setOpen: Function;
  setSelectedPartner: Function;
};

const PartnersTable = (props: PartnersTablePropType) => {
  const { partnersData, setOpen, setSelectedPartner } = props;
  const [sortDirection, setSortDirection] = useState("asc");
  const [totalSum, setTotalSum] = useState(0);
  const [seletedStatus, setSelectedStatus] = useState("active");

  

  const handleSort = () => {
    setSortDirection(sortDirection === "asc" ? "desc" : "asc");
  };

  const sortedPartners = [...partnersData].filter(partner=>{
    if(seletedStatus === "*"){
      return partner;
    }else{
      return partner.account.isActive === (seletedStatus === "active");
    }
  }).sort((a, b) => {
    const isAsc = sortDirection === "asc" ? 1 : -1;
    return (
      isAsc *
      generateClientName(a.investor)
        .toString()
        .localeCompare(generateClientName(b.investor))
    );
  });
  const sumOfPercentOwned = sortedPartners.reduce((total, partner) => {
    if (partner.account.isActive) {
      return total + partner.percentage;
    } else {
      return total;
    }
  }, 0);

  useEffect(() => {
    setTotalSum(sumOfPercentOwned);
  }, [partnersData, sumOfPercentOwned,seletedStatus]);

  return (
    <>
      <Stack
        spacing={2}
        direction="row"
        className="search-filter"
        
      >
        <FormControl style={{ width: 200 }}>
          <InputLabel id="status_label" shrink>
            Status
          </InputLabel>

          <Select
            labelId="status_label"
            label="Status"
            value={seletedStatus}
            onChange={(event: SelectChangeEvent) =>
              setSelectedStatus(event.target.value as string)
            }
            sx={{
              height: "40px", // Adjust this value as needed
              padding: "0 14px", // Adjust this value as needed
              "& .MuiSelect-select": {
                padding: "0px 0", // Adjust this value as needed
              },
            }}
          >
            <MenuItem value="*">All</MenuItem>
            <MenuItem value="active">Active</MenuItem>
            <MenuItem value="inactive">Inactive</MenuItem>
          </Select>
        </FormControl>
      </Stack>
      <TableContainer component={Paper} elevation={0}>
        <Table className="partners-table-container" aria-label="simple table">
          <caption>
            <div className="table-caption">
              <Typography className="total-label">Total</Typography>
              <Typography className="total-label mr-50">
                {totalSum.toFixed(4)} %
              </Typography>
            </div>
          </caption>
          <TableHead>
            <TableRow>
              <TableCell className="client-header" onClick={handleSort}>
                Client{" "}
                <span className="sort-icon">
                  {sortDirection === "asc" ? "▲" : "▼"}
                </span>
              </TableCell>
              <TableCell align="left" className="account-header">
                Account
              </TableCell>
              <TableCell align="right" className="percent-owned-header">
                Percent Owned
              </TableCell>
              <TableCell align="right"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedPartners.map((row) => (
              <TableRow
                key={row.id}
                className={row.account?.isActive ? "" : "grayed-out-row"}
              >
                <TableCell component="th" scope="row" className="row-cell">
                  {generateClientName(row.investor)}
                </TableCell>
                <TableCell align="left" className="row-cell">
                  {`${row.account.name} - ${row?.account?.accountNumber ?? ""}`}
                </TableCell>
                <TableCell align="right" className="row-cell">
                  {row.percentage} %
                </TableCell>
                <TableCell align="right" className="row-cell">
                  <EditRounded
                    className={
                      row.account?.isActive ? "edit-icon" : "disabled-icon"
                    }
                    onClick={() => {
                      if (row.account?.isActive) {
                        setSelectedPartner(row);
                        setOpen(true);
                      }
                    }}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default PartnersTable;
